export const INF_APP_VIEW_FORM_SIMPLE = '9';
export const INF_DOCTOR_LOAD = '15';
export const INF_CLIENT_DUP_NEW = '111';
export const INF_CLIENT_DUP_EDIT = '112';
export const INF_SYSTEM_RELOAD = '349';
export const INF_DIARY_CONFIRM_EQUIPMENT = '490';
export const INF_DIARY_CONFIRM_TIMETABLE = '505';
export const INF_DIARY_CONFIRM_OVERLAPPED = '506';
export const INF_DIARY_CONFIRM_ENOUGH_AUXILIARIES = '526';
export const INF_DIARY_CONFIRM_SKILLS = '536';
export const INF_DIARY_CONFIRM_SKILLS_NOBODY = '537';
export const INF_DIARY_APP_LOAD_PRO = '554';
export const INF_APP_VIEW_FORM_MULTIPLE = '556';
export const INF_CONSUMPTION_CABINET_LIST_LOAD = '648';
export const INF_DIARY_CONFIRM_TAG = '649';
